import { Component, signal } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ButtonColor, ButtonShape, ButtonSize, ButtonStyle } from 'shared/enums';
import { ButtonComponent } from 'shared/components/atoms';

interface ICellRendererParamsWithCustomProps extends ICellRendererParams {
  icon?: string;
  onClick?: () => void;
  showButton?: (params: ICellRendererParams) => boolean;
}

@Component({
    selector: 'app-cell-icon-button',
    template: `
    @if (showButton()) {
      <div class="flex h-full items-center justify-center">
        <app-button
          [shape]="ButtonShape.ROUNDED"
          [color]="ButtonColor.GRAY"
          [style]="ButtonStyle.TRANSPARENT"
          [size]="ButtonSize.SM"
          [icon]="icon"
          aria-label="Add item"
          (click)="handleClick()" />
      </div>
    }
  `,
    imports: [ButtonComponent],
    styles: `
    :host {
      width: 100%;
      height: 100%;
    }
  `
})
export class CellIconButtonComponent implements ICellRendererAngularComp {
  private params!: ICellRendererParams;
  public icon = 'add'; // Default icon
  public onClick: ((params: ICellRendererParams) => void) | undefined;
  public showButton = signal<boolean>(true);

  public agInit(params: ICellRendererParamsWithCustomProps): void {
    this.showButton.set(params.showButton?.(params) ?? false);
    this.params = params;
    this.icon = params.icon || 'add'; // Set the icon from params
    this.onClick = params.onClick; // Store the function reference
  }

  public refresh(): boolean {
    return false;
  }

  public handleClick(): void {
    this.onClick?.(this.params); // Call the function reference
  }

  protected readonly ButtonStyle = ButtonStyle;
  protected readonly ButtonShape = ButtonShape;
  protected readonly ButtonColor = ButtonColor;
  protected readonly ButtonSize = ButtonSize;
}
